import React, { useState } from 'react';

import Statistics from './statistics';
import Dashboard from './dashboard';
import Container from '../UI/atoms/Container';
import Text from '../UI/atoms/Text';
import Line from '../UI/atoms/Line';
import Grid from '../UI/atoms/Grid';
import Button from '../UI/atoms/Button';
import { useParams } from 'react-router-dom';
import { WakeUp } from 'common/interface/props';
export default function Admin() {
  const params = useParams();
  const solType = params.solType!.toUpperCase() as WakeUp;

  // 연동관리 타입 (통계, 상세조회)
  const [adminType, setAdminType] = useState(0);
  const name = adminType === 0 ? '통계관리' : '상세 조회';
  return (
    <Container>
      {/* <Button width={130} size="small" variant="outlined" color="main" type="button"> */}
      <Grid top={30} bottom={10}>
        <Text fontSize="2rem" fontWeight={600} color="#444">
          PLAYAPI {name}
        </Text>
        <Button
          type="button"
          color="main"
          variant="outlined"
          size="small"
          width={130}
          onClick={() => {
            setAdminType(0);
          }}
        >
          통계관리
        </Button>
        <Button
          type="button"
          color="main"
          variant="outlined"
          size="small"
          width={130}
          onClick={() => {
            setAdminType(1);
          }}
        >
          상세조회
        </Button>
      </Grid>
      <Line color="#e8e8e8" />
      {adminType === 0 ? <Statistics solType={solType} /> : <Dashboard solType={solType} />}
    </Container>
  );
}
